import { cssPropertiesIntersections } from './CssPropertiesIntersections';
import { IVirtualManifestItemMapping } from './types';
import { AbstractVirtualManifestBuilderWithActionableSlots } from './AbstractVirtualManifestBuilderWithActionableSlots';

export class IntersectionVirtualManifestBuilder extends AbstractVirtualManifestBuilderWithActionableSlots {
  reduceManifestEntity: AbstractVirtualManifestBuilderWithActionableSlots['reduceManifestEntity'] =
    (manifestProp, left, right, mappings) => {
      const valueA = left.value;
      const valueB = right.value;

      const _mappings: Record<string, IVirtualManifestItemMapping[]> = {};

      if (!valueA) {
        return {
          value: {
            ...(valueB ?? ({} as typeof valueA)),
          },
          mappings: { ...right.mappings },
        };
      }

      const intersection: typeof valueA = {};

      if (valueB) {
        const keys = Object.keys(valueB ?? {});

        keys.forEach((keyB) => {
          if (keyB in valueA) {
            // Safe type assertion: we know keyB exists in both valueA and the intersection type
            (intersection as any)[keyB] = (valueA as any)[keyB];

            if (!_mappings[keyB]) {
              _mappings[keyB] = [...(mappings[keyB] ?? [])];
            }

            _mappings[keyB].push(...(right.mappings[keyB] ?? []));
          } else {
            const possibleIntersections =
              cssPropertiesIntersections.getPossibleIntersections(keyB);

            possibleIntersections
              .filter((keyA) => keyA in valueA)
              .forEach((keyA) => {
                const result = cssPropertiesIntersections.isIntersected([
                  keyB,
                  keyA,
                ]);

                if (result) {
                  // Safe type assertion: we know result.key is a valid property key
                  (intersection as any)[result.key] =
                    (valueA as any)[result.key] ?? (valueB as any)[result.key];

                  if (!_mappings[result.key]) {
                    _mappings[result.key] = [...(mappings[result.key] ?? [])];
                  }

                  if (result.key !== keyA) {
                    // @ts-expect-error unknown vs string
                    _mappings[result.key] = mappings[keyA].map((mapping) => {
                      if (mapping.originalKey === keyA) {
                        return {
                          ...mapping,
                          encodeValue: result.encodeValue,
                          decodeValue: result.decodeValue,
                        };
                      }

                      return mapping;
                    });
                  }

                  _mappings[result.key].push(
                    ...(right.mappings[keyB] ?? []).map((m) =>
                      result.key === keyB
                        ? m
                        : {
                            ...m,
                            //  unknown vs string
                            encodeValue: result.encodeValue as any,
                            decodeValue: result.decodeValue as any,
                          },
                    ),
                  );
                }
              });
          }
        });
      }

      return {
        value: intersection,
        mappings: _mappings,
      };
    };
}
